import axios from 'axios';
import api from '../../services/api';
import ResponseError, { ErrorCode } from '../../types/response/ResponseError';
import { CancelTokenSource } from 'axios';
import { PagingResponseData } from '../../types/response/PagingResponseData';
import CheckoutSession from '../../types/paylink/CheckoutSession';

export interface PaylinkSearchOptions {
    ensureDefaults?: boolean;
    defaultQuery?: string;
    defaultPage?: string;
    defaultPerPage?: string;
}

export const normalizeSearchQueryString = (
    searchQueryString: string | undefined,
    options?: PaylinkSearchOptions
) => {
    const params = new URLSearchParams(
        searchQueryString?.startsWith('?') ? searchQueryString.slice(1) : searchQueryString ?? ''
    );

    if (options?.ensureDefaults) {
        if (options.defaultPerPage && !params.has('perPage')) {
            params.set('perPage', options.defaultPerPage);
        }

        if (!params.has('query')) {
            params.set('query', options.defaultQuery ?? '');
        }

        if (!params.has('page')) {
            params.set('page', options.defaultPage ?? '1');
        }
    }

    if (!params.has('query')) {
        params.set('query', '');
    }

    if (!params.has('page')) {
        params.set('page', '1');
    }

    if (!params.has('perPage')) {
        params.set('perPage', '30');
    }

    if (!params.getAll('filter').some(f => f.includes('checkoutType'))) {
        params.append('filter', 'checkoutType:["paylink"]');
    }

    const queryString = params.toString();

    return queryString === ''
        ? 'query=&page=1&perPage=30&filter=checkoutType:["paylink"]'
        : queryString;
};

export const searchPaylinks = async (
    searchQueryString: string | undefined,
    searchStarted: (phrase: string, cancelToken: CancelTokenSource) => void,
    searchSucceeded: (data: PagingResponseData<CheckoutSession[]>) => void,
    searchFailed: (error: ResponseError) => void,
    searchCanceled: () => void,
    options?: PaylinkSearchOptions
) => {
    const source = axios.CancelToken.source();
    const normalizedQuery = normalizeSearchQueryString(searchQueryString, options);
    const query = normalizedQuery.startsWith('?') ? normalizedQuery : `?${normalizedQuery}`;

    searchStarted(query, source);

    try {
        const response = await api.get<PagingResponseData<CheckoutSession[]>>(
            `checkouts${query}`,
            source.token
        );

        searchSucceeded(response);
    } catch (error) {
        const parsedError = error as ResponseError;

        if (parsedError.code === ErrorCode.CLIENT_CANCELED_ERROR) {
            searchCanceled();
        } else {
            searchFailed(error as ResponseError);
        }
    }
};

export const searchPaylinksOld = async (
    searchQueryString: string | undefined,
    searchStarted: (phrase: string, cancelToken: CancelTokenSource) => void,
    searchSucceeded: (data: PagingResponseData<CheckoutSession[]>) => void,
    searchFailed: (error: ResponseError) => void,
    searchCanceled: () => void
) => {
    const source = axios.CancelToken.source();
    let query = searchQueryString?.replace('%252C%2520', '');
    if (query === '') query = 'query=&page=1&perPage=30';
    if (!query?.startsWith('?')) query = `?${query}`;
    if (!query.includes('&filter=checkoutType')) query = `${query}&filter=checkoutType:["paylink"]`;

    searchStarted(query, source);

    try {
        const response = await api.get<PagingResponseData<CheckoutSession[]>>(
            `checkouts${query}`,
            source.token
        );

        searchSucceeded(response);
    } catch (error) {
        const parsedError = error as ResponseError;

        if (parsedError.code === ErrorCode.CLIENT_CANCELED_ERROR) {
            searchCanceled();
        } else {
            searchFailed(error as ResponseError);
        }
    }
};
